import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=270fad3e&lang=pug&"
import script from "./Matrix.vue?vue&type=script&lang=ts&"
export * from "./Matrix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Matrix.vue"
export default component.exports